import { _ } from "~/common/Utils";

const cloneMerge = (target, source) => {
    const clonedConfig = _.Object.Clone(target);

    return deepMerge(clonedConfig, source);
};

const deepMerge = (target, source) => {
    if (source === null) {
        return null;
    }

    const result = _.Object.Clone(target);

    Object.keys(source).forEach((key) => {
        if (isObject(target[key])) {
            result[key] = deepMerge(target[key], source[key]);
        }
        else {
            result[key] = source[key];
        }
    });

    return result;
};

const isObject = (obj) => {
    return obj != null && typeof obj === 'object' && !(obj instanceof Array);
}

const MergeModule = {
    cloneMerge: cloneMerge,
};

export default MergeModule;